import DemoMonarchSpecRouteScreen from "../../../src/features/arrangements/screens/DemoMonarchSpecRouteScreen";

export default function DemoMonarchCatchAllRoute() {
  return <DemoMonarchSpecRouteScreen />;
}
